<template>
  <div>

    <withdrawal-apply
      input="payment"
    />
  </div>

</template>

<script>
import WithdrawalApply from '@/views/withdrawal/apply/index'


export default {
  name: "payment-apply",
  components: {
    WithdrawalApply
  },
}
</script>

<style lang="less" scoped>
.initiate-payment {
  position: relative;

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center; /* Vertically center align */
    //gap: 5px; /* Space between the Slider and controls */
  }
  .step2-list {
    margin-left: 170px;
    height: 40px;
  }
  .step2-list-label {
    width: 130px; /* 设置相同的宽度 */
    text-align: right;
    padding-right: 10px;
  }
  .step2-list-text {
    text-align: left;
  }

  &__wrap {
    background-color: #fff;
    padding: 32px 0;
  }

  &__content {
    width: 75%;
    margin: 32px auto 0 auto;
  }

  &__steps {
    width: 75%;
    margin: 32px auto 0 auto;
  }

  &-list {
    padding: 40px;
    margin-left: 32px;
    margin-bottom: 32px;
    background-color: @m-bg-color;

    &__result {
      margin-left: 32px;
      margin-top: 32px;
      text-align: center;

      p {
        color: @m-content-color;
        margin-top: 10px;
        margin-bottom: 24px;
        font-weight: 600;
      }
    }

    &__row {
      margin-top: 16px;
    }

    &__label {
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      color: rgba(128, 134, 149, 1);
      line-height: 24px;
    }

    &__text {
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      color: rgba(23, 35, 61, 1);
      line-height: 24px;

      &--red {
        color: rgba(237, 64, 20, 1) !important;
      }
    }
  }

  &__toolbar {
    position: fixed;
    padding: 0 24px;
    bottom: 0;
    right: 24px;
    left: 280px;
    box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.06);
    height: 64px;
    line-height: 64px;
    text-align: right;
    background: #ffffff;
    border-radius: 0px 0px 6px 6px;

    &-btn {
      width: 100px;
      margin-left: 16px;
    }
  }

}
</style>
